module.exports = __webpack_public_path__ + "static/img/3.cbce476.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/su/3.jpg
// module id = vAI2
// module chunks = 1